export const HelveticaBold = "Helvetica Neue, Roboto, sans-serif";
export const Helvetica = "Helvetica Neue LT W01_55 Roman, Roboto, sans-serif";
export const HelveticaLight = "Helvetica Light, Roboto, sans-serif";